import React, { useState, useEffect } from 'react';
import './styles.css';
import poolPartyIconNoBackground from './../assets/poolpartyNoBackground.png';
import screenshot1 from './../assets/screenshot-1.png';
import screenshot2 from './../assets/screenshot-2.png';
import screenshot3 from './../assets/screenshot-3.png';
import screenshot4 from './../assets/screenshot-4.png';
import { Link } from 'react-router-dom';
import { GooglePlayButton, AppStoreButton } from "react-mobile-app-button";

const featureList = [
  { title: '👋 No Swiping', desc: 'Forget endless scrolling. Just meet people and vibe.' },
  { title: '🔓 Your Social Circle', desc: "See everyone you've connected with. No games." },
  { title: '💦 Control Your Pool', desc: 'Curate your circle. Only let good energy in.' },
  { title: '🎯 Filters That Matter', desc: 'Find people who match your vibe and interests.' },
  { title: '📍 Real-Time Locals', desc: "See who's in your city and ready to video chat *now*." },
  { title: '🚀 Boost & Super Splash', desc: 'Get noticed. Be seen. Make waves.' },
  { title: '📞 Call → Connect → Chat', desc: 'Start with video. If you click, unlock text. Simple.' },
  { title: '🤝 Human > Algorithm', desc: 'Real convos with real people. No creepy AI.' },
  { title: '🎉 Social Meets Spontaneous', desc: 'The fun, chaotic way to meet new friends.' }
];

const HomeScreen = () => {
  const [visibleStart, setVisibleStart] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setVisibleStart((prev) => (prev + 3) % featureList.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const renderHeaderNav = () => (
    <div className='home-screen-headerNav-container'>
      <div className='icon-header-container'>
        <img className='home-screen-icon' src={poolPartyIconNoBackground} alt="Pool Party Social Club Icon" />
        <h1 className="app-title">Pool Party Social Club</h1>
      </div>

      <div className='home-screen-nav-buttons-container'>
        <Link to="/" className="nav-link">Home</Link>
        <Link to="/features" className="nav-link">Features</Link>
        <Link to="/download" className="nav-link">Download</Link>
        <Link to="/contact" className="nav-link">Contact</Link>
      </div>
    </div>
  );

  const renderHeroSection = () => (
    <div className="hero-section">
      <h1 className="hero-title">Meet new friends through spontaneous face-to-face conversations</h1>
      <p className="hero-subtitle">Pool Party Social Club helps you break the ice and make real connections</p>
      <div className="download-buttons-container">
          <GooglePlayButton url={'https://play.google.com/store/apps/details?id=com.consolelog.poolparty'} theme={"dark"} className={"custom-google-play-button"} />
      </div>
    </div>
  );

  const renderIntroTextSection = () => (
    <div className="seo-text-section">
      <h2>What is Pool Party Social Club?</h2>
      <p>Pool Party Social Club is a next-gen <strong>social video app</strong> that brings people together through spontaneous, real-time video chats. Instead of scrolling through endless profiles, jump into a live pool of nearby people ready to connect face-to-face. It's authentic, local, and human-first socializing.</p>
      <p>With <strong>no algorithms controlling who you meet</strong>, you choose who to talk to. Simply splash someone to show interest or instantly call for a chance to connect. If you both vibe, texting becomes available. It's fast, real, and refreshingly unfiltered.</p>
    </div>
  );

  const renderScreenshotSection = () => (
    <div className="screenshot-gallery">
      <div className="screenshot-item">
        <img src={screenshot1} alt="Pool Party Social Club App" className="gallery-screenshot" />
      </div>
      <div className="screenshot-item">
        <img src={screenshot2} alt="Pool Party Social Club Features" className="gallery-screenshot" />
      </div>
      <div className="screenshot-item">
        <img src={screenshot3} alt="Pool Party Social Club Chat" className="gallery-screenshot" />
      </div>
      <div className="screenshot-item">
        <img src={screenshot4} alt="Pool Party Social Club Profile" className="gallery-screenshot" />
      </div>
    </div>
  );

  const renderSecondHeroSection = () => (
    <div className="hero-section-2">
      <h1 className="hero-title">Why text when you can talk?</h1>
      <p className="hero-subtitle">Start with a quick video chat. If you connect, unlock text messaging.</p>
    </div>
  );

  const renderFeatureCardsSection = () => (
    <div className="features-section">
      <div className="features-container">
        {featureList.slice(visibleStart, visibleStart + 3).map((feature, index) => (
          <div className="feature-card" key={index}>
            <h3>{feature.title}</h3>
            <p>{feature.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );

  const renderOutroTextSection = () => (
    <div className="seo-text-section">
      <h2>What makes Pool Party Social Club different?</h2>
      <p>Most <strong>social apps</strong> start with a text—an awkward, artificial message that rarely leads to anything meaningful. We've normalized <strong>ghosting</strong>, surface-level conversations, and endless scrolling that feel more like a game than an actual path to connection.</p>
      <p>Pool Party Social Club flips the script. By starting with a video chat, you're reminded that there's a real human on the other side. It's how <strong>real-life friendships</strong> work—face-to-face, spontaneous, and full of personality. No more pretending, no more waiting for replies that never come.</p>
      <p>We believe social apps should bridge the gap between people—not widen it. With <strong>live local video</strong>, you experience the kind of vibe that text can never deliver. This is socializing re-humanized.</p>
    </div>
  );

  return (
    <div className="home-screen-wrapper">
      {renderHeaderNav()}
      {renderHeroSection()}
      {renderScreenshotSection()}
      {renderIntroTextSection()}
      {renderSecondHeroSection()}
      {renderFeatureCardsSection()}
      {renderOutroTextSection()}
    </div>
  );
};

export default HomeScreen;
